import {StyleSheet} from 'react-native';
import {FONTS} from '../../utils/Constants';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    headerView: {
      marginHorizontal: 24,
    },
    scrollviewContainer: {
      paddingHorizontal: 24,
      paddingBottom: 20,
    },
    scrollView: {
      flex: 1,
      marginTop: 10,
    },
    rangeTextContainer: {
      padding: 16,
      backgroundColor: colors.backgroundMuted,
      borderRadius: 16,
      borderWidth: 1,
      borderColor: colors.borderMuted,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 12,
    },
    sectionHeaderContaier: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 24,
    },
    dotView: indicatorColor => ({
      height: 8,
      width: 8,
      borderRadius: 4,
      backgroundColor: indicatorColor,
      marginRight: 8,
    }),
    inputContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 12,
    },
    inputStyle: {
      fontFamily: FONTS.semiboldFont,
      fontSize: 18,
    },
    marginHorizontal16: {
      marginHorizontal: 16,
    },
    buttonContainer: {
      marginHorizontal: 24,
    },
  });

export default makeStyles;
